import React from 'react';
// import ReactDOM from 'react-dom';
import './dayjs-setup';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n/config';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './ServiceWorkerRegisteration';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  <App />
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
